import { menuAction } from '../../actions/menuActions';
import { createPanoramaHotspot } from '../../features/NonSequencedFlow/components/useHotspotMapFactory';
import { isHotspotCompletedSelector } from '../../features/tracking/services/CompletionService';
import { getMainProjectPanorama, getMainProjectPanoramaMaybe } from '../../globalPanoramaAccessor';
import { StudentThunkDispatch } from '../../types/redux';
import { StudentStore } from '../models/Store';
import { getItemByIdSelector, getItemByIdTypedSelector } from '../reducers/items/itemsSelectors';
import { trackingAction } from '../reducers/student/tracking/itemsTrackingActions';
import { isHotspot, isNonSequencedFlowItem } from '@ael/core-api';
import { FriendlyNameService } from '@ael/core-api';
import { Middleware, MiddlewareAPI } from '@reduxjs/toolkit';

let studentPanoramaMiddleware: Middleware<Record<string, unknown>, StudentStore, StudentThunkDispatch> | null = null;

export const provideStudentPanoramaMiddleware = () => {
  if (!studentPanoramaMiddleware) {
    studentPanoramaMiddleware = ({ dispatch, getState }: MiddlewareAPI<StudentThunkDispatch, StudentStore>) => {
      return (next: any) =>
        (action: any): any => {
          next(action);

          const currentState: StudentStore = getState();
          const getItemById = getItemByIdSelector(currentState);
          const getItemByIdTyped = getItemByIdTypedSelector(getState());

          switch (action.type) {
            case trackingAction.Tracking_ResetProgress:
              getMainProjectPanoramaMaybe()?.clear(); //add this to HTT, if reset progress will remove also link arrows
              break;
            case menuAction.SideMenu_SelectHotspot: {
              const hotspot = getItemByIdTyped(action.payload.hotspotId, isHotspot);
              getMainProjectPanoramaMaybe()?.lookToArrow(hotspot.position);
              break;
            }
            case trackingAction.Tracking_AddItem: {
              const currentItem = currentState.currentItem;
              if (currentItem) {
                const nonSequencedFlow = getItemById(currentItem);

                // CurrentHotspot is empty when the hotspot contains only the title
                if (isNonSequencedFlowItem(nonSequencedFlow) && currentState.currentHotspot.hotspot) {
                  const isCompleted = isHotspotCompletedSelector(currentState)(currentState.currentHotspot.hotspot);
                  if (isCompleted && getMainProjectPanoramaMaybe()) {
                    getMainProjectPanorama().removeArrow(
                      FriendlyNameService.getFriendlyName(currentState.currentHotspot.hotspot.id)
                    );
                    createPanoramaHotspot(
                      getMainProjectPanorama(),
                      currentState.currentHotspot.hotspot,
                      isCompleted,
                      getItemByIdTyped,
                      dispatch
                    );
                  }
                }
              }
              break;
            }
            default:
              break;
          }
        };
    };
  }

  return studentPanoramaMiddleware;
};
